import { Avatar, MenuItem, TextField, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { AccordionArrowPurple } from 'Images';
import { UseFormRegisterReturn } from 'react-hook-form';

interface ISelectInput {
  value: number;
  label: string;
  options: { id: number; value: string }[];
  register: UseFormRegisterReturn<string>;
  maxWidth?: string;
  error?: boolean;
  defaultOptionId?: number;
  noValueText?: string;
  ariaDescribedBy?: string;
  height?: string;
}

export const SelectInput = ({
  value,
  label,
  options,
  register,
  maxWidth,
  error,
  defaultOptionId,
  noValueText,
  ariaDescribedBy,
  height,
}: ISelectInput) => {
  const computedLabel = () => {
    if (!label) return ' ';

    if (value) {
      return ' ';
    } else {
      return label;
    }
  };

  return (
    <TextField
      select
      InputLabelProps={{ shrink: false }}
      size='small'
      SelectProps={{
        sx: {
          height: height,
          minHeight: height,
        },
        size: 'small',
        label: computedLabel(),
        value: value,
        defaultValue: defaultOptionId || undefined,
        id: `${label}-select`,
        labelId: `${label}-select-label`,
        error: error,
        ...register,
        inputProps: {
          'aria-label': label,
          'aria-describedby': ariaDescribedBy,
        },
        MenuProps: {
          PaperProps: {
            sx: {
              color: 'text.secondary',
              borderRadius: 0,
              borderBottomLeftRadius: '16px',
              borderBottomRightRadius: '16px',
              boxShadow: '0px 4px 24px rgba(45, 112, 217, 0.16)',
              padding: '0',
              maxHeight: '200px',
              border: '1px solid',
              borderTop: 0,
              borderColor: 'blue',
            },
          },
        },
        IconComponent: (props) => (
          <Avatar
            {...props}
            src={AccordionArrowPurple}
            alt={''}
            sx={{ width: '32px', height: '32px' }}
          />
        ),
      }}
      sx={{
        borderRadius: '8px',
        bgcolor: '#fff',
        top: '-1px',
        width: maxWidth || '100%',
        flexShrink: 0,

        fieldSet: {
          marginTop: '6px',
        },

        '& .MuiOutlinedInput-notchedOutline': {
          borderRadius: '8px',
          borderColor: 'primary.shade_200',
          borderWidth: '1px',
        },
        '.MuiInputLabel-root': {
          fontWeight: 400,
        },
        '.MuiOutlinedInput-root': {
          fontWeight: 400,

          '&:hover fieldset': {
            borderColor: 'primary.main',
          },
          '&.Mui-focused fieldset': {
            borderColor: 'primary.main',
            borderWidth: '1px',
          },
        },
        '& .MuiSelect-select': {},
        '& .MuiSelect-icon': {
          cursor: 'pointer',
          top: 'auto',
        },
        '.MuiSelect-iconOpen': {
          top: 'auto',
        },
        height: height,
        minHeight: height,
      }}
    >
      {noValueText && (
        <MenuItem
          key={`blank-${label}`}
          id={`blank-${label.trim().replace(' ', '-')}`}
          value={-1}
          sx={{
            fontWeight: 400,
            padding: '13px 0px 13px 20px',

            ':hover, :focus': {
              backgroundColor: '#E7EDFF',
              fontWeight: 700,
            },
          }}
        >
          <Typography variant={'body3'} color={error ? '#d32f2f' : undefined}>
            {noValueText || ''}
          </Typography>
        </MenuItem>
      )}
      {options.map((option, index) => {
        return (
          <MenuItem
            key={index}
            sx={{
              fontWeight: '400',
              fontSize: '18px',
              ':hover, :focus': {
                backgroundColor: '#F2F9FF',
                fontWeight: 700,
              },
            }}
            value={option.id}
          >
            {option.value}
          </MenuItem>
        );
      })}
    </TextField>
  );
};
